import { useComments } from 'hooks/comments'
import React from 'react'
import Comment from './Comment'
import 'stylesheets/MainAppStyles/CommentsList.css'
const CommentList = ({ note }) => {
    const { id } = note
    const { comments, isLoading } = useComments(id)

    if (isLoading) return ""

    return (
        <div className='comment-list-container'>
            {comments.map((comment) => (
                <Comment key={comment.id} comment={comment}/>
            ))}
        </div>
    )
}

export default CommentList